import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/comprehensive-medical-information-services")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/comprehensive-medical-information-services"),
  component: PVOffering,
});

